import {useI18n} from '@/hooks/useI18n';
import InvoiceImageViewer from './InvoiceImageViewer';
import PDFViewer from './PDFViewer';

export default function DocumentViewer({src, mimeType, alt = 'Document'}) {
  const {t} = useI18n();
  if (!src) {
    return (
      <div className="border border-border rounded-lg p-8 text-center">
        <div className="text-4xl mb-2">📄</div>
        <p className="text-muted-foreground">{t('documents.noDocument', 'common')}</p>
      </div>
    );
  }

  // Determine document type
  // Check both file extension and MIME type for robustness
  const isPDF =
    mimeType === 'application/pdf' || src.toLowerCase().endsWith('.pdf');
  const isImage =
    mimeType?.startsWith('image/') ||
    /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(src);

  if (isPDF) {
    return <PDFViewer src={src} alt={alt} />;
  } else if (isImage) {
    return <InvoiceImageViewer src={src} alt={alt} />;
  } else {
    // Fallback for unknown file types
    return (
      <div className="border border-border rounded-lg p-8 text-center">
        <div className="text-4xl mb-2">📄</div>
        <p className="text-muted-foreground">{t('documents.unknownType', 'common')}</p>
        <p className="text-sm text-muted-foreground mt-1">
          {t('documents.mimeType', 'common')} {mimeType}
        </p>
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-block px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90">
          {t('actions.downloadFile', 'common')}
        </a>
      </div>
    );
  }
}
